import React, {useState} from 'react';
import AlertPiece from '../ScreenComponents/AlertPiece';
import WrappedPanel from './WrappedPanel';
import NavBar from '../ScreenComponents/NavBar';
import AllContents from '../ContentItems/AllContents';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as EditorFunctions from '../utilities/EditorFunctions';

function App(props) {

  var clickItem = props.clickItem;
  var itemT = props.itemT;
  var addPath = props.addPath;
  var width = props.width;
  var height = props.height;
  var insetWidth = props.insetWidth;
  var insetHeight = props.insetHeight;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var chains = props.chains;
  var anItemSet = props.anItemSet;
  var index = props.index;
  var pPiece = props.pPiece;
  var classCover = props.classCover;

  var refObject = {};
  var urlParamsForExecution = '';
  var urlHeader = 'https://www.cues.sg/dapps/XXXX';
  var lastEdited = '';

  const [otherInfo, setOtherInfo] = useState({});
  const [inputValues, setInputValues] = useState({});


  if (!currentList){
    return <div></div>
  }
//


  function nullFn(e){
    if (e && e.stopPropagation){
      e.stopPropagation();
    }
  }

  function doubleNullFn(){
    return nullFn
  }
  var isError = false;
  var interactionFn = nullFn;
  var ownVariables = {};
  var upwardInfo = [];


    var anItem = anItemSet.v;

    var currentListA = JSON.parse(JSON.stringify(currentList));
    currentListA.as = JSON.parse(JSON.stringify(anItemSet.as));
    var internalVariablesHere = StyleFunctions.getInternalVariables(otherInfo, setOtherInfo, {t:'fe', v:''});

    var path = addPath.concat([index]);
    if (itemT === 'navBar'){
      path = addPath;
    }

    var thisItem1 = JSON.parse(JSON.stringify(anItemSet.v));

    var changeTab = nullFn;

    EditorFunctions.doASetOfUploadOrDownloadTemplateModifiers(thisItem1, itemT, path, 'elementDownloadMods', currentListA, chains, changeTab);

    function insertAtLocation(path, insertWhat, insertWhere){

      for (var i = 0; i < path.length - 1; i++){
        insertWhere = insertWhere[path[i]];
      }
      insertWhere[path[path.length - 1]] = insertWhat;
    }

    insertAtLocation(path, thisItem1, currentListA);

    var editPieces = {getRef1:nullFn, refObject:{}, updatesToPropagate:[], organicChanges, onClickItemChangeSelection:nullFn, error:false, otherPeoplesPositions:[]};

    var userNos = -1;
    var userID = -1;
    var otherPeoplesPositions = [];
    var updatesToPropagate = [];
    var potentiallyAddWhichItem = false;
    var popUps = [];
    var setPopUps = nullFn;
    var screenSelectionChoices = false;
    var alertVisibility = {};
    var onClickItemChangeSelection = nullFn;
    var hoveringWhere = false;
    var actHoveringWhere = nullFn;
    var isShowingSomeDropDown = false;
    var setIsShowingSomeDropDown = nullFn;
    var setScreenSelectionChoices = nullFn;
    var itemEdited = false;
    var setItemEdited = nullFn;
    var doAScreenRef = nullFn;
    var getRef1 = nullFn;
    var setIsClickingOnContentDivHere = nullFn;
    var isClickingOnContentDiv = false;
    var tabSelected = false;

    var scale = width * 0.4 / insetWidth;
    var sStyle = {overflow:'scroll'};
    sStyle.height = height * 0.4 / scale;
    sStyle.marginBottom = '5px';
    sStyle.zoom = scale;
    sStyle.mozTransform = 'scale(' + scale + ') translate(-100%, -150%)';
    sStyle.mozTransformOrigin = 'scale(' + scale + ') 0';
    sStyle.msZoom = scale;
    sStyle.webkitZoom = scale;

    if (itemT === 'ALERT'){
      return <div className='col-6' ><div className='checkboard' style={{border:'', padding:'5px', marginTop:'10px', cursor:'pointer'}} onClick={clickItem}><div style={sStyle} ><AlertPiece chains={chains} thisAlertVariant={thisItem1} alertPath={path} currentList={currentListA} internalVariables={internalVariablesHere} insetWidth={insetWidth} insetHeight={insetHeight} upwardInfo={upwardInfo} inputValues={inputValues} ownVariables={ownVariables} itemEdited={itemEdited} error={isError} interactionFn={interactionFn} isDraggingDetails={false} popUps={popUps} setPopUps={setPopUps} setItemEdited={setItemEdited} getRef1={getRef1} organicChanges={organicChanges} otherPeoplesPositions={otherPeoplesPositions} dragStart={nullFn} dragEnd={nullFn} updatesToPropagate={updatesToPropagate} userNos={userNos} userID={userID} setInputValues={setInputValues} isShowingSomeDropDown={isShowingSomeDropDown} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} hoveringWhere={hoveringWhere} actHoveringWhere={actHoveringWhere} potentiallyAddWhichItem={potentiallyAddWhichItem} addWhereText={''} isClickingOnContentDiv={isClickingOnContentDiv} setIsClickingOnContentDiv={setIsClickingOnContentDivHere} onDrag={nullFn} refObject={refObject} clickEditItem={doubleNullFn} onClickItemChangeSelection={onClickItemChangeSelection} setIsShowingSomeDropDown={setIsShowingSomeDropDown} showRelatives={true} doAScreenRef={nullFn} flashHighlight={false} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} lastEdited={lastEdited} counter={0}/></div>{pPiece}
      </div></div>
//
    }else if (itemT === 'PANEL' || itemT === 'FOOTER'){

      return <WrappedPanel chains={chains} sStyle={sStyle} insetWidth={insetWidth} path={path} inputValues={inputValues} setInputValues={setInputValues} alertVisibility={alertVisibility} internalVariablesHere={internalVariablesHere} upwardInfo={upwardInfo} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} organicChanges={organicChanges} userNos={userNos} userID={userID} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} itemEdited={itemEdited} setItemEdited={setItemEdited} onClickItemChangeSelection={onClickItemChangeSelection} getRef1={getRef1} setIsShowingSomeDropDown={setIsShowingSomeDropDown} setIsClickingOnContentDivHere={setIsClickingOnContentDivHere} currentListA={currentListA} insetHeight={insetHeight} interactionFn={interactionFn} otherPeoplesPositions={otherPeoplesPositions} updatesToPropagate={updatesToPropagate} isError={isError} isShowingSomeDropDown={isShowingSomeDropDown} potentiallyAddWhichItem={potentiallyAddWhichItem} hoveringWhere={hoveringWhere} actHoveringWhere={actHoveringWhere} popUps={popUps} setPopUps={setPopUps} ownVariables={ownVariables} doAScreenRef={doAScreenRef} refObject={refObject} isClickingOnContentDiv={isClickingOnContentDiv} pPiece={pPiece} clickItemOut={clickItem} lastEdited={lastEdited}/>

    }else if (itemT === 'navBar'){
      return <div className='col-6' ><div className='checkboard' style={{border:'', padding:'5px', marginTop:'10px', cursor:'pointer'}} onClick={clickItem}><div style={sStyle} ><NavBar organicChanges={organicChanges} chains={chains} currentList={currentListA} internalVariables={internalVariablesHere} width={insetWidth} height={insetHeight} inputValues={inputValues} ownVariables={ownVariables} navBarPath={addPath} navBarPathOrig={[index]} itemEdited={itemEdited} setItemEdited={setItemEdited} interactionFn={interactionFn} error={isError} actHoveringWhere={actHoveringWhere} hoveringWhere={hoveringWhere} changeTab={changeTab} tabSelected={tabSelected} isShowingSomeDropDown={isShowingSomeDropDown} flashHighlight={false} doAScreenRef={doAScreenRef} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader}/></div>{pPiece}
      </div></div>
//
    }else{
      var xx = <AllContents userID={userID} chains={chains} height={insetHeight} width={insetWidth} currentList={currentListA} internalVariables={internalVariablesHere} interactionFn={interactionFn} inputValues={inputValues} setInputValues={setInputValues} itemEdited={false} setItemEdited={false} thisItem={anItem} itemInfoPath={path} stylesToAdd={{}} clickEditItem={doubleNullFn} editPieces={editPieces} needToShowError={false} addClassNames={''} dragStuff={null} parentalType={''} setIsClickingOnContentDiv={setIsClickingOnContentDivHere} isClickingOnContentDiv={false} upwardInfo={upwardInfo} addWhereText={''} potentiallyAddWhichItem={false} organicChanges={organicChanges} userNos={-1} hoveringWhere={false} actHoveringWhere={nullFn} screenSelectionChoices={false} setScreenSelectionChoices={nullFn} popUps={{}} setPopUps={nullFn} ownVariables={ownVariables} doAScreenRef={nullFn} flashHighlight={false} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} lastEdited={lastEdited} counter={0}/>

        if (classCover === 'container'){
          return <div className='col-6' ><div className='checkboard' style={{border:'', padding:'5px', marginTop:'10px', cursor:'pointer'}} onClick={clickItem}><div style={sStyle} className='container'>{xx}</div>
        {pPiece}
      </div></div>
//
        }else if (classCover === 'col-3'){
          return <div className={classCover + ' checkboard'} style={{padding:'5px', margin:'5px', cursor:'pointer'}} onClick={clickItem}>{xx}{pPiece}
      </div>;
    //
        }else{
          return <div className='col-6' ><div className='checkboard' style={{border:'', padding:'5px', marginTop:'10px', cursor:'pointer'}} onClick={clickItem}><div style={sStyle} >{xx}</div>{pPiece}
      </div></div>
        }

    }
//   }

}


//
export default App;
